export default __webpack_public_path__ + "static/media/Katie_Krienitz_Krimitsos_AHV_In_Moms_We_Trust.a6fdb593.jpg";